import Vue from 'vue'
import {ActionTree, MutationTree} from 'vuex'
import {RootState} from '@/store/types'

import {Show} from '@/store/modules/lib'
import axios from 'axios';
import alerts from '@/store/modules/alerts';
import i18n from "@/helpers/i18n";

export interface Push {
  id:string,
  title: string,
  text: string,
  timestamp:string,
  audience:string,
  shows:[string],
  status?:string
}

export interface State {
  pushes:Push[] | null
}


const defaultState: State = {
 pushes:null
};

const getters = {
  pushes: (state: State) => state.pushes
}

const mutations: MutationTree<State> = {
  setPushes(state: State, payload: [Push]) {
    state.pushes = payload
  },
  deletePush(state: State, payload: string) {

    if(state.pushes){
      console.log(payload)
      console.log(state.pushes)
     const arr:Push[] = state.pushes.filter((v:any)=> v.id != payload)
      state.pushes = arr
    }

  },
  addPush(state: State, payload: Push) {
    if (state.pushes) state.pushes.unshift(payload)

  }
}

const actions: ActionTree<State, RootState> = {
  async loadPushesFromServer({commit, state},payload:string) {
    try {
      const {data} = await Vue.axios.get('/v4/notification')
      commit('setPushes', data.data)
      this.commit('alerts/setAlert', {
        show: true,
        messages: [i18n.t('notifications.pushes.load')]
      })
    } catch (e) {
      this.commit('alerts/setAlert',{
        show:true,
        color:'red',
        messages:[e.message]
      })
    }
  },
  async deletePushFromServer({commit, state},payload:string) {
    try {
      const {data} = await Vue.axios.delete('/v4/notification/' + payload)
      if(data.data.status === 'ok'){
        commit('deletePush', payload)
        this.commit('alerts/setAlert', {
          show: true,
          messages: [i18n.t('notifications.pushes.delete')]
        })
      } else {
        throw(data)
      }

      return true
    } catch (e) {
      this.commit('alerts/setAlert',{
        show:true,
        color:'red',
        messages:[e.message]
      })
      return false
    }
  },
  async savePushFromServer({commit, state},payload:object) {
    try {
      const {data} = await Vue.axios.post('/v4/notification', payload)
      commit('addPush', data.data)
      this.commit('alerts/setAlert', {
        show: true,
        messages: [i18n.t('notifications.pushes.add')]
      })
      return true
    } catch (e) {
      this.commit('alerts/setAlert',{
        show:true,
        color:'red',
        messages:[e.message]
      })
      return false
    }
  },


}

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
  actions
}
